import { TitleId } from '@common';
import { FormOption } from '../models/form-option.interface';

export const titleIdOptions: FormOption<TitleId>[] = [
  { label: 'Mr', value: TitleId.Mr },
  { label: 'Mrs', value: TitleId.Mrs },
  { label: 'Ms', value: TitleId.Ms },
  { label: 'Miss', value: TitleId.Miss },
  { label: 'Mx', value: TitleId.Mx },
];
